import {

	Blog2BlogImg1,
	Blog2BlogImg2,
	Blog2BlogImg3

} from '../../utils/allImgs'


export const dataDown = [
	{
		img:Blog2BlogImg1,
		title:"EU council reunites",
		text:"Nov 29, 2021"
	},
	{
		img:Blog2BlogImg2,
		title:"A new way to travel the world",
		text:"March 29, 2021"
	},
	{
		img:Blog2BlogImg3,
		title:"Why choose a bank?",
		text:"March 29, 2021"
	}
]


// export default data